var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18280_3749",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.332031,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18280_3749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3393 17.1673C9.35385 17.1673 8.42545 16.9809 7.55406 16.6082C6.68281 16.2354 5.9199 15.722 5.26531 15.0682C4.61073 14.4143 4.09691 13.6523 3.72385 12.7823C3.35066 11.9125 3.16406 10.983 3.16406 9.99398C3.16406 9.00482 3.35045 8.07801 3.72323 7.21357C4.09601 6.34926 4.60934 5.58982 5.26323 4.93523C5.91712 4.28065 6.67906 3.76683 7.54906 3.39378C8.41892 3.02058 9.34837 2.83398 10.3374 2.83398C11.3266 2.83398 12.2534 3.02037 13.1178 3.39315C13.9821 3.76593 14.7416 4.27926 15.3961 4.93315C16.0507 5.58704 16.5645 6.34732 16.9376 7.21398C17.3108 8.08065 17.4974 9.00669 17.4974 9.99211C17.4974 10.9775 17.311 11.9059 16.9382 12.7773C16.5655 13.6486 16.0521 14.4115 15.3982 15.0661C14.7443 15.7207 13.9841 16.2345 13.1174 16.6075C12.2507 16.9807 11.3247 17.1673 10.3393 17.1673ZM10.3307 16.5007C12.0252 16.5007 13.4835 15.9382 14.7057 14.8132C15.928 13.6882 16.6224 12.2993 16.7891 10.6465L16.797 10.6544C16.8024 10.6598 16.7998 10.6518 16.7891 10.6304C16.6961 10.7095 16.5939 10.7695 16.4822 10.8107C16.3705 10.8519 16.2389 10.8725 16.0872 10.8725H12.6384C12.2965 10.8725 12.0037 10.7509 11.7601 10.5077C11.5166 10.2647 11.3949 9.97246 11.3949 9.63107V8.76044H8.4076V7.01898C8.4076 6.6776 8.52941 6.38405 8.77302 6.13836C9.01649 5.89266 9.3092 5.76982 9.65115 5.76982H10.523V4.62878C10.523 4.34892 10.6032 4.131 10.7634 3.97503C10.9237 3.81905 11.1182 3.73732 11.3468 3.72982C11.209 3.64121 11.0376 3.58086 10.8326 3.54878C10.6276 3.51669 10.4603 3.50065 10.3307 3.50065C8.52517 3.50065 6.99045 4.1326 5.72656 5.39648C4.46267 6.66037 3.83073 8.1951 3.83073 10.0007V10.2411C3.83073 10.3158 3.83608 10.3959 3.84677 10.4815H7.91406C8.6192 10.4815 9.21003 10.7197 9.68656 11.1961C10.163 11.6726 10.4011 12.261 10.4011 12.9613V13.8404H7.78594V16.0119C8.16941 16.1763 8.57663 16.2989 9.0076 16.3796C9.43871 16.4603 9.87976 16.5007 10.3307 16.5007Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgState);
export default __webpack_public_path__ + "static/media/state.3c6ed0b01540f30aa996f4353eac4a09.svg";
export { ForwardRef as ReactComponent };